import { UI_API_METHOD_TYPES, type UiCaptureAppErrorRequest } from '@sdk/api/modules/ui/types.ui'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Send an app error to Pitcher sentry instance.
 *
 * @example
 * try {
 *   throw new Error('This is an error')
 * } catch (error) {
 *   useUi().captureAppError(error)
 * }
 *
 * @param payload error object to send to Pitcher sentry instance
 */
export async function captureAppError(payload: UiCaptureAppErrorRequest): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, UI_API_METHOD_TYPES.UI_CAPTURE_APP_ERROR, payload)
}
